import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Table",
  "use": "Table-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"Table\"><defs><path d=\"M6 4h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2Zm0 2v5h5V6H6Zm0 7v5h5v-5H6Zm7-7v5h5V6h-5Zm0 7v5h5v-5h-5Z\" id=\"Table_a\" /></defs><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h24v24H0z\" /><use fill=\"#495973\" xlink:href=\"#Table_a\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol